import React, { useEffect, useState } from "react";
import Sidebar from "../../../layout/Sidebar";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

import AdminDataTable from "../../../components/common/AdminDataTable";
import { educationColumns } from "../../../tables/educationColumns";
import { can } from "../../../utils/can";


export default function Education() {
  const PAGE_SIZE = 10;
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const [success, setSuccess] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);
  const token = localStorage.getItem("adminToken");
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  

  // Religion list state
  const [educationList, setEducationList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [listLoading, setListLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [activeSearch, setActiveSearch] = useState("");



  const API_URL = process.env.REACT_APP_BASE_URL_API || ""; // make sure no trailing slash

  const fetchEducation = async (pageNumber = 1, pSize = pageSize, currentSearch = activeSearch) => {
    setListLoading(true);

    try {
      // Ensure no double slash
      let url = `${API_URL.replace(/\/$/, "")}/api/admin/education?page=${pageNumber}&limit=${pSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`;
      if (currentSearch && currentSearch.trim()) {
        url += `&search=${encodeURIComponent(currentSearch.trim())}`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();

      if (response.ok) {
        setEducationList(result.data);
        const computedTotal = result.totalPages
          ? result.totalPages
          : Math.ceil((result.totalCount || result.data.length || 0) / pSize) || 1;
        setTotalPages(computedTotal);
      } else {
        console.error(result.message || "Failed to fetch data.");
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setListLoading(false);
    }
  };


  useEffect(() => {
    fetchEducation(page, pageSize, activeSearch);
  }, [page, pageSize, sortBy, sortOrder, activeSearch]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setPage(1);
    setActiveSearch(searchInput);
    fetchEducation(1, pageSize, searchInput);
  };

  const handleSearchReset = () => {
    setSearchInput("");
    setActiveSearch("");
    setPage(1);
    fetchEducation(1, pageSize, "");
  };

  // form submit
  const onSubmit = async (data) => {
      if(can("education","create") === false){
            alert("You don't have permission.");
            return;
        }

    setSuccess("");
    setErrorMsg("");
    setLoading(true);

    try {

      const url = editId
                  ? `${API_URL.replace(/\/$/, "")}/api/admin/education/update/${editId}`
                  : `${API_URL.replace(/\/$/, "")}/api/admin/education/create`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          name: data.name.trim(),
          education_type:data.education_type,
          status: data.isActive ? 'Active' : 'Deactive',
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setSuccess(editId ? "Education updated successfully!" : "Education added successfully!");
        setErrorMsg("");
        reset(); // clear form
        setEditId(null);
        fetchEducation(page, pageSize, activeSearch);
      } else {
        setErrorMsg(result.message || "Failed to save education.");
      }
    } catch (err) {
      console.error("Error:", err);
      setErrorMsg("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  
  const handleEdit = (item) => {
    if(can("education","edit") === false){
            alert("You don't have permission.");
            return;
        }
    setValue("name", item.name);
    setValue("education_type", item.education_type);
    setValue("isActive", item.status === "Active");
    setEditId(item._id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  
  const handleDelete = async (id) => {
    if(can("education","delete") === false){
            alert("You don't have permission.");
            return;
        }
    if (!window.confirm("Are you sure you want to delete this record?")) return;
    try {
      const response = await fetch(`${API_URL.replace(/\/$/, "")}/api/admin/education/delete/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      if (response.ok) {
        setSuccess("Education deleted successfully.");
        fetchEducation(page, pageSize);
      } else {
        setSuccess(result.message || "Failed to delete education.");
      }
    } catch (err) {
      console.error(err);
      setSuccess("Something went wrong!");
    }
  };

    const columns = educationColumns(handleEdit, handleDelete, pageSize);
  

  return (
    <div class="container body">
      <div class="main_container">
        <Sidebar />
        <Header pageTitle="Education" />
        {/* page */}
        <div className="right_col" role="main">
          {/* top tiles */}
        
          {/* /top tiles */}
          {/* body card start */}
          <div className="x_panel">
            <div className="x_title">
              <h2>Education Entry</h2>
              <ul className="nav navbar-right panel_toolbox" style={{ minWidth: 1 }}>
                <li>
                  <Link to="#" className="collapse-link">
                    <i className="fa fa-chevron-up" />
                  </Link>
                </li>

              </ul>
              <div className="clearfix" />
            </div>
            <div className="x_content">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-sm-12">
                    {/* filter start */}
                    <div className="filtercont">
                      <div className="row">
                        <div className="col-12 col-sm-4 pr-lg-0 mb-3">
                          <label>Enter Education Name</label>
                          <input
                            type="text"
                            className={`form-control ${errors.name ? "is-invalid" : ""}`}
                            {...register("name", { required: "Please enter education name" })}
                          />
                          {errors.name && (
                            <div className="text-danger mt-1">{errors.name.message}</div>
                          )}
                          
                        </div>
                        <div className="col-12" />
                        <div className="col-12 col-sm-4 pr-lg-0 mb-3">
                          <label>Select Type</label>
                          <select className="form-control" {...register("education_type", { required: "Please select type" })}>
                              <option value="">Select</option>
                              <option value="1">PG</option>
                              <option value="2">Graduation</option>
                            </select>
                          {errors.education_type && (
                            <div className="text-danger mt-1">{errors.education_type.message}</div>
                          )}
                          
                        </div>
                        <div className="col-12" />
                        <div className="col-12 col-sm-4 pr-lg-0">
                          <input type="checkbox" id="active" {...register("isActive")} /> {" "}
                          <label htmlFor="active" className="form-label">
                            {" "} Active / Deactive
                          </label>
                        </div>
                        <div className="col-12" />
                        <div className="col-12 col-sm-4 pr-lg-0 text-right">
                          <button type="submit" className="btn sitebtn" disabled={loading}>
                            {loading ? "Submitting..." : "Submit"}
                          </button>
                          {success && <div className="text-success mt-1">{success}</div>}
                          {errorMsg && <div className="text-danger mt-1">{errorMsg}</div>}
                        </div>
                      </div>
                    </div>
                    {/* filter end */}
                  </div>
                </div>
              </form>
            </div>
          </div>
          {/* bod card end */}
          {/* body card start */}
          <div className="x_panel">
            <div className="x_title">
              <h2>Education List</h2>
              <ul className="nav navbar-right panel_toolbox" style={{ minWidth: 1 }}>
                <li>
                  <Link to="#" className="collapse-link">
                    <i className="fa fa-chevron-up" />
                  </Link>
                </li>

              </ul>
              <div className="clearfix" />
            </div>
            <div className="x_content">
              {/* Search Bar */}
              <div className="row mb-3">
                <div className="col-12 col-md-6 col-lg-4">
                  <form onSubmit={handleSearchSubmit}>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search education..."
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                      />
                      <button className="btn sitebtn mb-0" type="submit" style={{ borderRadius: "0 4px 4px 0" }}>
                        <i className="fa fa-search" /> Search
                      </button>
                      {(activeSearch || searchInput) && (
                        <button
                          className="btn btn-secondary mb-0 ms-1 ml-1"
                          type="button"
                          onClick={handleSearchReset}
                        >
                          Reset
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>

              <div className="row">
                <AdminDataTable
                columns={columns}
                data={educationList}
                page={page}
                pageSize={pageSize}
                totalPages={totalPages}
                loading={listLoading}
                onPageChange={setPage}
                onPageSizeChange={(size) => {
                  setPageSize(size);
                  setPage(1);
                }}
                sortBy={sortBy}
                sortOrder={sortOrder}
              />
              </div>
            </div>
          </div>
          {/* bod card end */}
        </div>

        {/* page end */}
        <Footer />

      </div>
    </div>
  );
}